module.exports = __webpack_public_path__ + "static/media/githubIcon.e5eb5ae1.svg";